import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Coupon } from 'types/coupon'
import { Icon } from 'components/base-ui'
import { LabelSemiBoldSmall, LabelSemiBoldTiny, LinkSmall } from 'components/base-ui/FontsV2'
import {
  Wrapper,
  CouponImage,
  CouponDetails,
  Condition,
  FlexContainer,
  TitleSection,
  ColumnContainer,
  Tag,
} from './style'

interface CouponItemProps {
  coupon: Coupon
  detail: ReactNode
  onClickCondition?: (serialNumber: string) => void
  tag?: string
  inActive?: boolean
}

const CouponItem = ({
  coupon: { serialNumber, thumbnailImageURL, name },
  onClickCondition,
  detail,
  tag = '',
  inActive = false,
}: CouponItemProps) => {
  const { t } = useTranslation()
  const thumbnailImage = thumbnailImageURL ? thumbnailImageURL : '/assets/generic/promotions/coupon16x9.svg'

  return (
    <Wrapper $inActive={inActive}>
      <CouponImage src={thumbnailImage} alt="coupon" />
      <CouponDetails>
        <TitleSection>
          <LabelSemiBoldSmall>{name}</LabelSemiBoldSmall>
          {tag && (
            <Tag>
              {
                <LabelSemiBoldTiny color="white" noWrap>
                  {tag}
                </LabelSemiBoldTiny>
              }
            </Tag>
          )}
        </TitleSection>
        <FlexContainer>
          <ColumnContainer>{detail}</ColumnContainer>
          {onClickCondition && (
            <Condition onClick={() => onClickCondition(serialNumber)}>
              <LinkSmall noWrap>{t('dineIn.coupon.condition')}</LinkSmall>
              <Icon name="caret-right" size="10px" />
            </Condition>
          )}
        </FlexContainer>
      </CouponDetails>
    </Wrapper>
  )
}

export default CouponItem
